// /client/packs/controllers/player_id_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  validate() {
    const input = this.inputTarget
    let error = input.parentNode.querySelector(".invalid-feedback")
    if ((input.value.length > 10 || input.value.length < 1)) {
      input.classList.add("is-invalid")
      if (!error) {
        error = document.createElement("div")
        error.classList.add("invalid-feedback")
        error.innerText = "Player ID cannot be blank or more than 10 characters"
      }
      input.parentNode.insertBefore(error, input.nextSibling)
    } else {
      if (error) {
        input.classList.remove("is-invalid")
        error.remove()
      }
    }
  }

  handleInput(event) {
    const input = this.inputTarget

    // Allow only numbers (0-9) and backspace key
    const allowedChars = new RegExp(/^\d|\b$/)
    if (!allowedChars.test(event.data)) { return }

    const newValue = input.value.slice(0, 10)
    input.value = newValue.replace(/[^0-9\b]/g, "")
  }
}